import {array, Decoder, field, number, object} from 'json-bouncer'

export interface Paginated<T> {
    readonly data: T[]
    readonly totalCount: number
}

export function paginatedDecoder<T>(dataDecoder: Decoder<T>): Decoder<Paginated<T>> {
    return object({
        data: field('data', array(dataDecoder)),
        totalCount: field('totalCount', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/Paginated.ts